import { registerSW } from 'virtual:pwa-register';

/** Bring the service worker up, and take a new one only at a moment that cannot
 *  lose anything. A todo list has no long-lived editor state worth protecting, but
 *  it does have a sheet you might be halfway through typing into — so an update
 *  waits for the app to be in the background and reloads then, rather than
 *  swapping the page out from under a half-written task. */
export function registerServiceWorker() {
  const update = registerSW({
    onNeedRefresh() {
      const apply = () => {
        if (document.visibilityState === 'visible') return;
        document.removeEventListener('visibilitychange', apply);
        void update(true);
      };
      document.addEventListener('visibilitychange', apply);
    },
  });
}
